import { Components, Theme } from '@mui/material/styles';

export const muiFormControlLabelOverride: Components<Theme>['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      marginLeft: 0,
      marginRight: 0,
      marginBottom: theme.spacing(2),
      '& .MuiTypography-root': {
        fontWeight: 400,
        fontSize: 16,
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        marginBottom: theme.spacing(2),
        paddingRight: 0,
        [theme.breakpoints.down('md')]: {
          fontSize: 14,
        },
      },
    }),
  },
};
